<template>
  <tr :class="{clickable: $_loggedUser_action_allowed('operators', 'read')}" @click="onRowClick()">
    <td class="no_padding drag_drop"><span></span></td>
    <td class="no_padding">
      <input type="checkbox"
             :id="entity.id"
             :value="entity.id"
             @change="onChange"
             :checked="isChecked"
             @click.stop
      />
      <label :for="entity.id" @click.stop v-translate>Vybrat</label>
    </td>
    <td :data-th="'Operator' | translate" class="first_data">{{ entity.name }}</td>
    <td class="no_padding"></td>
  </tr>
</template>

<script>
	export default {
		name: "MacAddressRow",
		props: {
			entity: Object,
      selectedEntities: Array
		},
		methods: {
      onChange: function (e) {
        this.$emit('input', e)
      },
      onRowClick() {
        if(this.$_loggedUser_action_allowed('operators', 'read')) {
          this.$router.push({name: 'operatorDetail', params: {id: this.entity.id}})
        }
      },
		},
    computed: {
      isChecked() {
        return this.selectedEntities.indexOf(String(this.entity.id)) > -1
      }
    }
	}
</script>



// WEBPACK FOOTER //
// src/components/views/businessModels/tabs/OperatorRow.vue